module.exports = __webpack_public_path__ + "img/anip.693d1aa6.png";